import { store } from '../Store/Store'

export function orchestrateConsole() {
  ;(window as any).besacc = (window as any).besacc ?? {}
  const besacc = (window as any).besacc

  besacc.getLocalization = () => {
    console.log(JSON.stringify(store.getState().interface.localization))
  }

  besacc.getCompanies = () => {
    const cutOff = new Date('2024-02-18').getTime()
    console.log(
      JSON.stringify(
        store
          .getState()
          .data.companies.filter(
            (c) =>
              c.vatNumber.length > 2 &&
              c.vatNumber.substring(0, 2) === 'BE' &&
              (c.lastKpbCheck == null ||
                c.lastKpbCheck < cutOff ||
                c.lastKpbCheckSuccess == null ||
                !c.lastKpbCheckSuccess)
          )
      )
    )
  }
}
